//
// Copyright 2020 The MathWorks, Inc

// Added the below rule to silence the ESLint max-len warning

/* eslint-disable max-len */

//
// DO NOT MODIFY THIS FILE!!  This is a derived file.
// Instead, modify the English message catalog XML file "resources/RTW/en/buildStatus.xml"
// Note, that Non-English message catalog XML files are derived from their English counterpart.
//
// Encoding: UTF-8

define({ root:
({
    Actions: "ACTIONS",
    AutoOpenChk: "Open automatically during build",
    Blocked: "Blocked",
    BuildStatus: "Build Status",
    Building: "Building",
    CancelBuildAct: "Cancel Build",
    Canceled: "Canceled",
    Canceling: "Canceling",
    CodeGenTargets: "Code Generation Targets",
    Completed: "Completed",
    ElapsedTime: "Elapsed Time",
    Error: "Error",
    Help: "Help",
    MissingLicense: "Build status window requires Simulink Coder and MATLAB Coder licenses.",
    ModelName: "Model Name",
    ModelStatusListNoBuildStatus: "No existing build status to show.",
    NoExistingBuildStatus: "No Existing Build Status",
    NumActiveWorkers: "Number of Active Workers",
    OpenPAAct: "Open\nPerformance Advisor",
    OpenPAText: "*Open Performance Advisor for more details",
    OptPoolSize: "Optimal Pool Size",
    Options: "OPTIONS",
    OverallProgressText: "Completed Models",
    Pending: "Pending",
    Scheduled: "Scheduled",
    SimTargets: "Simulation Targets",
    Status: "Status",
    WasUpToDate: "Up To Date",
    invalidTargetType: "Invalid system target type '${0}'. Target type must be one of the following: { 'SIM', 'RTW' }."
}),
"ja-jp": true
});
